import { normalizeCursor } from '../../pagination';
import type { PageInfo } from '../../types';
import { googleFetch } from '../client';

export type GoogleDriveSharedDrive = {
  id: string;
  name: string;
  createdTime?: string;
  hidden?: boolean;
};

export type GoogleDriveDrivesListRequest = {
  cursor?: string;
  page_token?: string;
  page_size?: number;
};

export type GoogleDriveDrivesListResponse = {
  drives: GoogleDriveSharedDrive[];
  cursor?: string | null;
  is_truncated?: boolean;
  next_page_token?: string;
  page_info?: PageInfo;
};

export async function googleDriveDrivesList(
  params: GoogleDriveDrivesListRequest
): Promise<GoogleDriveDrivesListResponse> {
  const { cursor, page_token, ...rest } = params;
  const resolvedPageToken = cursor ?? page_token;
  const response = await googleFetch<GoogleDriveDrivesListResponse>(
    '/rpc/google_drive_drives_list',
    {
      body: {
        ...rest,
        cursor,
        page_token: resolvedPageToken,
      },
    }
  );
  return {
    ...response,
    page_info: normalizeCursor(response),
  };
}
